// extracted by mini-css-extract-plugin
export default {"value":"Value_value__kGC28","value__img":"Value_value__img__B12YL","value__title":"Value_value__title__+GLSM","value__text":"Value_value__text__GslVx"};